
import React, { useState } from 'react';
import { Navbar } from './components/Navbar';
import { MobileBottomNav } from './components/MobileBottomNav';
import { HeroComponent } from './components/Hero'; 
import { About } from './components/About';
import { Space } from './components/Space';
import { Workshops } from './components/Workshops';
import { Articles } from './components/Articles';
import { Booking } from './components/Booking';
import { MoodSpace } from './components/MoodSpace';
import { Footer } from './components/Footer';
import { Tab } from './types';

const App: React.FC = () => {
  const [activeTab, setActiveTab] = useState<Tab>('home');

  const renderContent = () => {
    switch (activeTab) {
      case 'home':
        return <HeroComponent onNavigate={setActiveTab} />;
      case 'about':
        return <About />;
      case 'articles':
        return <Articles />;
      case 'space':
        return <Space />;
      case 'workshops':
        return <Workshops />;
      case 'booking':
        return <Booking />;
      case 'mood':
        return <MoodSpace />;
      default:
        return <HeroComponent onNavigate={setActiveTab} />;
    }
  };

  const handleLogoClick = () => {
    setActiveTab('home');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleAboutClick = () => {
    setActiveTab('about');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen flex flex-col selection:bg-amber-100 selection:text-stone-700 bg-[#fcfbf9]">
      {/* 桌面端 Navbar */}
      <Navbar activeTab={activeTab} setActiveTab={setActiveTab} />
      
      {/* 
        移动端重塑顶栏 (Earth Tone Header)
        背景：#f5f1ee (温暖的浅杏色/土)
        Logo位置改为“启程”，字体风格与右侧“关于我”保持一致
      */}
      <header className="md:hidden fixed top-0 left-0 right-0 z-[90] bg-[#f5f1ee] border-b border-stone-200/40 h-16 flex items-center justify-between px-6">
        <div 
          onClick={handleLogoClick} 
          className="flex items-center cursor-pointer active:opacity-70 transition-opacity"
        >
          {/* 左侧“启程”：使用与右侧关于我相同的 typography */}
          <span className={`
            font-serif text-[13px] font-black tracking-[0.3em] py-2 transition-all duration-300
            ${activeTab === 'home' ? 'text-amber-700' : 'text-stone-900'}
          `}>
            启程
          </span>
        </div>
        
        <div className="flex items-center">
          <button 
            onClick={handleAboutClick}
            className={`
              font-serif text-[13px] font-black tracking-[0.3em] py-2 transition-all duration-300
              ${activeTab === 'about' 
                ? 'text-amber-700' 
                : 'text-stone-500 hover:text-stone-800 active:opacity-60'
              }
            `}
          >
            关于我
          </button>
        </div>
      </header>

      {/* 
        主内容区域：
        pt-16 (移动端新顶栏高度), md:pt-32 (桌面端)
      */}
      <main className="flex-grow pt-16 md:pt-32 pb-14 md:pb-0">
        {renderContent()}
      </main>
      
      <Footer />
      
      {/* 移动端固定底栏 */}
      <MobileBottomNav activeTab={activeTab} setActiveTab={setActiveTab} />
    </div>
  );
};

export default App;
